import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { defineAsyncComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'back-button',
  props: {
    isLogout: { type: Boolean },
    buttonText: { default: 'back' }
  },
  emits: ["btnClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'btnClick'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLogout?: boolean, buttonText: string };

const IconS3 = defineAsyncComponent(() => import('@white-label-icon/icons-s3'));

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;





const backButtonText = computed(() => {
  const text = `UI.buttons.${props.buttonText}`;
  return  proxy.$t?.(text) ?? text;
});

return { __sfc: true,IconS3, instance, proxy, emit, props, backButtonText }
}

})